import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function G1() {
    const { useLang } = useGlobal();
    const { t } = useLang('outdoorrecreation');

    return (
        <div id="outdoor-recreation-G" className={`outdoor-recreation-G1 ${css['outdoor-recreation-G1']}`}>
            <EcoImg
                pc="https://websiteoss.ecoflow.com/figma-uploads/1786954348343-f21dre-compressed-004.webp"
                h5="https://websiteoss.ecoflow.com/figma-uploads/1786954374642-lgrd3y-compressed-004.webp"
                alt={t('secG_title')}
                aria-label={t('secG_title')}
            />
            <div className="info">
                <p className="title">{t('secG_title')}</p>
                <p className="desc">{t('secG_desc')}</p>
            </div>
        </div>
    );
}
